import apiV2 from '../api/v2';

// Accounts > Practice detail > Overview tab's "Submissions" and "Approvals"
// cards - week/month/year bucketed, zero-filled, oldest first (12/12/5
// buckets respectively). Bucket label: week -> YYYY-MM-DD (Monday
// week-start), month -> YYYY-MM, year -> YYYY.
export type PatientInsightsGranularity = 'week' | 'month' | 'year';

export interface PracticePatientInsightsBucket {
    bucket: string;
    submissions: number;
    approvals: number;
}

export interface PracticePatientInsights {
    granularity: PatientInsightsGranularity;
    buckets: PracticePatientInsightsBucket[];
}

export function patientInsightsWindowLabel(granularity: PatientInsightsGranularity): string {
    switch (granularity) {
        case 'week':
            return 'Last 12 weeks';
        case 'year':
            return 'Last 5 years';
        default:
            return 'Last 12 months';
    }
}

export async function fetchPracticePatientInsights(
    practiceId: string,
    granularity: PatientInsightsGranularity
): Promise<PracticePatientInsights> {
    const response = await apiV2.get<{ success: boolean; data: PracticePatientInsights }>(
        `/practices/${practiceId}/patient-insights`,
        { params: { granularity } }
    );
    return response.data.data;
}
